import React from 'react';

function ErrorPage(props) {
    return (
        <div>
            <h3>oops!!! No page found</h3>
            <a href='/'>Back to HomePage</a>
        </div>
    );
}

export default ErrorPage;